package frontend.modals

import AccountSelect
import AddressSelect
import ErrorString
import androidx.compose.runtime.*
import net.sergeych.ugdx.shared.ApiException
import net.sergeych.ugdx.shared.SignedInvoice
import net.sergeych.ugdx.shared.api.ApiAccount
import com.ionspin.kotlin.bignum.decimal.BigDecimal
import com.ionspin.kotlin.bignum.decimal.toBigDecimal
import components.TButton
import components.TForm
import components.TLink
import components.TTextInput
import frontend.App
import frontend.DepositContext
import frontend.components.Modal
import frontend.lib.MetaMask
import frontend.lib.classList
import frontend.lib.displayCurrencyCode
import frontend.pages.AccountAttachModal
import frontend.pages.InvoicesContext
import frontend.pages.Wallet
import kotlinx.coroutines.InternalCoroutinesApi
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text
import kotlin.math.sign


@Composable
fun InvoicePayModal(context: InvoicesContext, signedInvoice: SignedInvoice, onClose: () -> Unit) {
    val scope = rememberCoroutineScope()
    var error: String? by mutableStateOf(null)
    var isLoading by remember { mutableStateOf(false) }
    val filtered = context.user.accounts.filter { it.currencyCode == signedInvoice.invoice.currencyCode }
    var fromAccount: ApiAccount? by remember { mutableStateOf(filtered.firstOrNull()) }

    fun pay(fromAccount: ApiAccount?) {
        error = ""
        if (fromAccount == null) { error = "Select account"; return }

        isLoading = true

        scope.launch {
            try {
                signedInvoice.pay(fromAccount)
                onClose()
            } catch(e: ApiException) {
                error = e.text
            }
        }
    }

    Modal(onClose = { onClose() }) {
        TForm() {
            H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
                Text("Select account to pay ${signedInvoice.invoice.total.toPlainString()} ${displayCurrencyCode(signedInvoice.invoice.currencyCode)}")
            }

            AccountSelect("fromAccount", fromAccount) {
                options(filtered)
                onChange { fromAccount = it }

                label {
                    Text("")
                }
            }

            if (error !== null) ErrorString(error ?: "")

            TButton(attrs = {
                onClick { pay(fromAccount) }
                isLoading(isLoading)
            }) {
                Text("Pay")
            }
        }
    }
}
